import { render } from "./Transfer.vue?vue&type=template&id=d1455f3c&scoped=true&ts=true"
import script from "./Transfer.vue?vue&type=script&lang=ts"
export * from "./Transfer.vue?vue&type=script&lang=ts"

import "./Transfer.vue?vue&type=style&index=0&id=d1455f3c&scoped=true&lang=scss"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1455f3c"]])

export default __exports__